import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CampusProofCard} from '../ProofEdit/CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {ProductSelector} from '../ProductSelector/ProductSelector';
import {browserHistory} from 'react-router';

/* root for image */
declare var ServerUrlRoot: string;

class ProductProps extends Tgcc.BaseProps {
    product: Tgcc.Product;
}

const imgStyle: React.CSSProperties = {
    maxHeight: '180px',
    maxWidth: '180px',
    height: 'auto',
    width: 'auto',
    alignSelf: 'center',
    display: 'flex'
}

const labelStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransformm: 'uppercase'
}

const cStyle: React.CSSProperties ={
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    marginTop:'10px'
}

const btnCont: React.CSSProperties = {
    marginTop:'10px'
}
class _IndigoProductEdit extends React.Component<ProductProps, Tgcc.GlobalState> {

    openProduct = () => {browserHistory.push(Tgcc.Routes.IndigoProductListView)}

    handleMissingProductImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    getProductImage(){
        if(this.props.product){
            var p = this.props.product;
            var image = Tgcc.getProductPath(this.props.product.thumbnail.replace(' ', '%20'))
            return ( 
                <div style={cStyle}>
                    <img src={image} style={imgStyle} onError={this.handleMissingProductImage}/>
                    <div style={labelStyle}>{p.brand}&nbsp;{p.style}</div>
                    <div style={labelStyle}>{p.colorName}</div>
                </div>
            );
        }
    }

    render() {
        var btnText: string = this.props.product ? "Change apparel" : "Choose apparel";
        return (
            <div>
                <CampusProofCard title="2. Apparel">
                <div style={btnCont}>                   
                    <CampusButton text={btnText}  onClick={this.openProduct} color="white" backgroundColor="#DF735B" lineHeight="3.0em" margin='auto' fontSize='10px'/>
                </div>
                    { this.getProductImage() }                   
                </CampusProofCard>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { product: state.ActiveProof.product }
};

export var IndigoProductEdit = connect(mapStateToProps)(Radium(_IndigoProductEdit));